export const aboutData = {
  brand: {
    title: "关于云体育",
    subtitle: "让运动融入你的每一天",
    description: "云体育成立于2024年，是专注于体育运动的一站式在线服务平台。我们致力于通过科技手段让每个人都能随时随地享受专业的体育运动体验。经过两年的快速发展，云体育已成长为国内领先的在线体育运动平台，累计服务超过500万用户。",
    mission: "我们的使命是打破时间与空间的限制，让专业的体育运动服务触手可及。无论您是健身达人还是运动新手，云体育都能为您提供最适合的运动解决方案。",
  },
  milestones: [
    { year: "2024年3月", event: "云体育平台正式上线，推出赛事直播和运动课程两大核心服务" },
    { year: "2024年8月", event: "注册用户突破100万，上线AI智能健身计划功能" },
    { year: "2025年1月", event: "完成A轮融资，上线体育资讯频道" },
    { year: "2025年6月", event: "推出会员体系，注册用户突破300万" },
    { year: "2026年1月", event: "上线社区互动功能，月活跃用户突破200万" },
    { year: "2026年6月", event: "用户总数突破500万，成为国内领先的在线体育平台" },
  ],
  honors: [
    { title: "2025年度最佳体育科技平台", org: "中国体育产业协会" },
    { title: "2025年最具创新力企业", org: "互联网体育峰会" },
    { title: "2026年度用户最喜爱运动App", org: "年度体育盛典" },
    { title: "2026年数字化创新标杆企业", org: "国家体育总局" },
    { title: "质量管理体系认证", org: "ISO 9001:2025" },
    { title: "信息安全管理认证", org: "ISO 27001:2025" },
  ],
  contact: {
    address: "北京市朝阳区奥林匹克商务区云体育大厦",
    phone: "400-888-6688",
    email: "contact@yunsports.com",
    workingHours: "周一至周日 9:00 - 21:00",
  },
  faqs: [
    {
      question: "云体育是一家什么样的公司？",
      answer: "云体育是专注于体育运动的一站式在线服务平台，总部位于北京。我们提供体育赛事直播、运动课程、健身计划、体育资讯等全场景服务，致力于让每个人都能随时随地享受专业的体育运动体验。",
    },
    {
      question: "如何成为云体育的合作伙伴？",
      answer: "如果您是健身教练、运动机构或体育内容创作者，欢迎通过我们的商务合作邮箱 partner@yunsports.com 与我们联系，我们会在3个工作日内回复您的合作咨询。",
    },
    {
      question: "云体育的数据安全如何保障？",
      answer: "云体育已通过ISO 27001信息安全管理体系认证，所有用户数据均采用银行级加密存储，严格遵守国家个人信息保护相关法律法规，确保您的隐私安全。",
    },
  ],
};